import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserLoginService } from '../Common/UserLoginService/userlogin.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

interface ExpiredStatusData {
  statusMessage: string | null;
  endDate: string;
  overdueDays: number;
  baseAmount: number;
  extraUserBlocks: number;
  extraUserAmount: number;
  monthlySubtotal: number;
  gstPercent: number;
  gstAmount: number;
  monthlyTotalAmount: number;
  planId: number;
}

@Component({
  selector: 'app-subscription-expired',
  templateUrl: './subscription-expired.component.html',
  styleUrls: ['./subscription-expired.component.css']
})
export class SubscriptionExpiredComponent implements OnInit {

  statusData: ExpiredStatusData | null = null;
  qrCodeUrl: SafeUrl = '';

  readonly bankDetails = {
    accountNo: '7350335127',
    bankName: 'Kotak Mahindra Bank',
    ifscCode: 'KKBK0002113',
    gstin: '27ABCCA3726D2Z0',
    upiId: 'advinsoftwares@kotak',
    beneficiary: 'Advin Softwares'
  };

  copiedField: string | null = null;

  constructor(
    private router: Router,
    private userLoginService: UserLoginService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    // Read status data passed from HomeComponent
    const raw = sessionStorage.getItem('expiredSubscriptionData');
    if (raw) {
      try { this.statusData = JSON.parse(raw); } catch { /* ignore */ }
    }

    // Build UPI QR code URL — include amount and tenant note so UPI apps pre-fill them
    const amount = this.statusData?.monthlyTotalAmount ? Math.round(this.statusData.monthlyTotalAmount) : null;
    const tenantId = this.userLoginService.User()?.companyId ?? '';
    const tn = `AdvERP Subscription Renewal | Tenant: ${tenantId} | Amt: INR ${amount}`;
    const amountParam = amount ? `&am=${amount}&tn=${encodeURIComponent(tn)}` : '';
    const upiString = `upi://pay?pa=${this.bankDetails.upiId}&pn=${encodeURIComponent(this.bankDetails.beneficiary)}&cu=INR${amountParam}`;
    const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(upiString)}`;
    this.qrCodeUrl = this.sanitizer.bypassSecurityTrustUrl(qrApiUrl);
  }

  copyToClipboard(value: string, field: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.copiedField = field;
      setTimeout(() => { this.copiedField = null; }, 2000);
    });
  }

  logout(): void {
    this.userLoginService.SignOutUser();
  }
}
